<template>
  <b-modal
    id="modal-material-category-edit"
    :title="$t('reference.edit_category')"
    cancel-variant="outline-secondary"
    :ok-title="$t('edit')"
    :ok-variant="'warning'"
    :cancel-title="$t('cancel')"
    centered
    no-close-on-backdrop
    @show="showModal"
    @ok="onSubmitCategory"
  >
    <b-form>
      <validation-observer ref="insValidations">
        <b-tabs content-class="pt-1" fill>
          <b-tab active :title="$t('reference.name') + ' uz'">
            <b-form-group :label="$t('reference.name')" for="titleUz">
              <validation-provider
                #default="{ errors }"
                :name="$t('reference.name')"
                rules="required"
              >
                <b-form-input id="titleUz" v-model="category.title.uz" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('reference.name') + ' ru'">
            <b-form-group :label="$t('reference.name')" for="titleRu">
              <validation-provider
                #default="{ errors }"
                :name="$t('reference.name') + 'ru'"
                rules="required"
              >
                <b-form-input id="titleRu" v-model="category.title.ru" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-tab>
        </b-tabs>
      </validation-observer>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BTabs,
  BTab,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions } from "vuex";

export default {
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BTabs,
    BTab,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    editCategory: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  data() {
    return {
      // ===============  PRIMARY_DATA_SECTION START ===============
      category: {
        title: {
          uz: "",
          ru: "",
        },
      },
      // ===============  PRIMARY_DATA_SECTION END ===============
    };
  },
  methods: {
    ...mapActions("materials", [
      "UPDATE_PRODUCT_CATEGORY",
      "FETCH_PRODUCT_CATEGORIES",
    ]),

    // ===============  SHOW_MODAL_SECTION START ===============
    showModal() {
      console.log(this.editCategory);
      this.category = {
        title: {
          uz: "",
          ru: "",
        },
      };

      if (!this.editCategory) {
        return;
      }

      if (typeof this.editCategory === "object" && this.editCategory !== null) {
        if (!this.editCategory.title) {
          return;
        }
        this.category.title.uz = this.editCategory.title_full.uz;
        this.category.title.ru = this.editCategory.title_full.ru;
      }
    },
    // ===============  SHOW_MODAL_SECTION END ===============

    // ===============  ON_SUBMIT_SECTION START ===============
    onSubmitCategory(bvModalEvt) {
      bvModalEvt.preventDefault();

      this.$refs.insValidations.validate().then((success) => {
        if (success) {
          try {
            if (this.editCategory.id) {
              this.UPDATE_PRODUCT_CATEGORY({
                id: this.editCategory.id,
                data: this.category,
              }).then(() => {
                this.FETCH_PRODUCT_CATEGORIES({ page_size: 1000 });
              });
            }

            this.$nextTick(() => {
              this.$bvModal.hide("modal-material-category-edit");
            });

            this.category = {
              title: {
                uz: "",
                ru: "",
              },
            };

            this.$_okToast();
          } catch (err) {
            this.$_errToast(err);
          }
        } else {
          this.$_errToast({message: this.$t('all_fields_are_required')});
          return;
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============
  },
};
</script>

<style scoped>
</style>
